import styled from 'styled-components';
import {
  ClientOnlyModal,
  ModalProps,
} from '@pass-frontend/common/components/modal/ui';
import { useIntl } from '@pass-frontend/common/i18n';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

export interface NotEligibleModalProps {
  onRequestedClose: ModalProps['onRequestedClose'];
  isOpen: ModalProps['isOpen'];
}

const StyledNotEligibleModal = styled(ClientOnlyModal)`
  &.modal {
    width: calc(100% - 32px);
    height: auto;
    margin: 16px;
    padding-bottom: 16px;

    ${MEDIA_QUERY.desktop} {
      width: 600px;
      padding: 40px;
    }
  }

  border-radius: 17px;
  .body {
    margin: 24px 0 0 0;
  }

  .close-btn {
    border: none;
    color: #222222;
    margin-bottom: 24px;

    .system-close {
      height: 14px;
      width: 14px;
    }
  }
`;
const ModalBody = styled.div`
  margin-bottom: 40px;

  .modal-body-one {
    margin-bottom: 16px;
  }
`;
const ModalTitle = styled.h1.attrs({
  className: 'is-display-flex is-h3 has-text-blue-1',
})`
  margin: 24px 0;
`;

const GotItButton = styled.div.attrs({
  className: 'is-display-flex is-justify-content-end',
})`
  button {
    ${MEDIA_QUERY.mobileAndTablet} {
      width: 100%;
      height: 32px;
      padding: 6px 0;
    }
  }

  &:hover {
    text-decoration: none;
  }
`;

export function NotEligibleModal(props: NotEligibleModalProps) {
  const { t } = useIntl();
  return (
    <StyledNotEligibleModal
      className="modal"
      data-testid="not-eligible-modal"
      ariaHeadingId="notEligibleModal"
      ariaLabel={t('notEligibleModal.title')}
      onRequestedClose={props.onRequestedClose}
      shouldHideHeading={true}
      overlayZIndex={1001}
      {...props}
    >
      <>
        <ModalTitle>{t('notEligibleModal.title')}</ModalTitle>
        <ModalBody className="is-body-2-regular has-text-primary">
          <div data-testid="not-eligible-bodyOne" className="modal-body-one">
            {t('notEligibleModal.bodyOne')}
          </div>
          <div data-testid="not-eligible-bodyTwo">
            {t('notEligibleModal.bodyTwo', {
              phoneNumber: (
                <span className="is-body-2-bold">
                  {t('notEligibleModal.phoneNumber')}
                </span>
              ),
            })}
          </div>
        </ModalBody>
        <GotItButton>
          <button
            type="button"
            className="btn btn-primary"
            onClick={props.onRequestedClose}
            data-ui-element-name="got-it-btn"
          >
            {t('notEligibleModal.gotItButton')}
          </button>
        </GotItButton>
      </>
    </StyledNotEligibleModal>
  );
}

export default NotEligibleModal;
